
import React from 'react';
import {LockIcon} from 'Icons';

const AccessDeniedPage: React.FC<{access?: string; module?: string}> = ({ access='view', module='this module' }) => {
    return (
        <div className="flex justify-center min-h-screen bg-slate-50 p-4">
        <div
            className="text-center p-8 bg-white shadow-lg rounded-lg w-full"
            role="alert"
            aria-live="assertive"
        >
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
            <LockIcon />
            </div>
            <h1 className="mt-6 text-2xl font-bold text-gray-900">
            Access Denied
            </h1>
            <p className="mt-4 text-gray-600">
                You do not have the necessary permissions to <b>{access}</b> {module}.
            </p>
            <p className="mt-2 text-sm text-gray-500">
                Please contact your system administrator if you believe this is an error.
            </p>
        </div>
        </div>
    );
};

export default AccessDeniedPage;